
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import ProductModal from '../../components/feature/ProductModal';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function MasculinoPage() {
  // SEO effect
  useEffect(() => {
    updateSEO({
      ...seoData.masculino,
      canonical: `${getBaseURL()}/masculino`,
      ogTitle: seoData.masculino.title,
      ogDescription: seoData.masculino.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [sortBy, setSortBy] = useState('featured');
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const filters = ['All', 'New In', 'Shirts', 'Pants', 'Jackets', 'Accessories', 'Line 1.1', 'Line 1.2'];
  const sortOptions = [
    { value: 'featured', label: 'Featured' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'newest', label: 'Newest' }
  ];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/308bd99d676c0d4dd3320d0a8a48cc7e.jpg.1%20quality%2C%20high-end%20menswear%20fashion%20photography%2C%20sophisticated%20fabric%20texture%20with%20emerald%20green%20accents%2C%20professional%20product%20photography%20on%20white%20background%2C%20luxury%20brand%20aesthetic%20with%20golden%20details&width=400&height=500&seq=dluxmen-polo-masc-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Polo Shirt Super Clone 1.1',
      price: 'R$ 189,90',
      originalPrice: 'R$ 249,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20gucci%20style%20shirt%20for%20men%2C%20premium%20cotton%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20style%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-gucci-shirt-1&orientation=portrait',
      brand: 'GUCCI',
      name: 'Classic Cotton Shirt',
      price: 'R$ 229,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20prada%20style%20casual%20pants%20for%20men%2C%20premium%20fabric%20quality%20with%20sophisticated%20cut%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20trousers%20with%20emerald%20green%20accents&width=400&height=500&seq=dluxmen-prada-pants-1&orientation=portrait',
      brand: 'PRADA',
      name: 'Casual Premium Pants',
      price: 'R$ 279,90',
      originalPrice: 'R$ 349,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20armani%20style%20blazer%20for%20men%2C%20sophisticated%20tailoring%20with%20premium%20materials%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20jacket%20with%20emerald%20green%20brand%20elements&width=400&height=500&seq=dluxmen-armani-blazer-1&orientation=portrait',
      brand: 'ARMANI',
      name: 'Executive Blazer',
      price: 'R$ 449,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20versace%20style%20t-shirt%20for%20men%2C%20premium%20cotton%20with%20sophisticated%20print%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20tee%20with%20emerald%20green%20brand%20accents&width=400&height=500&seq=dluxmen-versace-tshirt-1&orientation=portrait',
      brand: 'VERSACE',
      name: 'Designer T-Shirt',
      price: 'R$ 159,90',
      originalPrice: 'R$ 199,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20dolce%20gabbana%20style%20jeans%20for%20men%2C%20premium%20denim%20with%20sophisticated%20wash%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20jeans%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-dg-jeans-1&orientation=portrait',
      brand: 'DOLCE & GABBANA',
      name: 'Premium Denim Jeans',
      price: 'R$ 319,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20hugo%20boss%20style%20sweater%20for%20men%2C%20premium%20wool%20fabric%20with%20sophisticated%20knit%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20pullover%20with%20emerald%20green%20accents&width=400&height=500&seq=dluxmen-boss-sweater-1&orientation=portrait',
      brand: 'HUGO BOSS',
      name: 'Wool Sweater',
      price: 'R$ 289,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20ralph%20lauren%20style%20polo%20for%20men%2C%20premium%20cotton%20pique%20with%20sophisticated%20collar%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20polo%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-ralph-polo-1&orientation=portrait',
      brand: 'RALPH LAUREN',
      name: 'Classic Polo',
      price: 'R$ 199,90',
      originalPrice: 'R$ 259,90'
    },
    {
      id: '9',
      image: 'https://readdy.ai/api/search-image?query=luxury%20calvin%20klein%20style%20underwear%20set%20for%20men%2C%20premium%20cotton%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20underwear%20with%20emerald%20green%20accents&width=400&height=500&seq=dluxmen-ck-underwear-1&orientation=portrait',
      brand: 'CALVIN KLEIN',
      name: 'Premium Underwear Set',
      price: 'R$ 89,90'
    },
    {
      id: '10',
      image: 'https://readdy.ai/api/search-image?query=luxury%20tommy%20hilfiger%20style%20jacket%20for%20men%2C%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20outerwear%20with%20emerald%20green%20brand%20elements&width=400&height=500&seq=dluxmen-tommy-jacket-1&orientation=portrait',
      brand: 'TOMMY HILFIGER',
      name: 'Sport Jacket',
      price: 'R$ 359,90'
    },
    {
      id: '11',
      image: 'https://readdy.ai/api/search-image?query=luxury%20lacoste%20style%20polo%20shirt%20for%20men%2C%20premium%20cotton%20pique%20with%20sophisticated%20crocodile%20logo%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20polo%20with%20emerald%20green%20accents&width=400&height=500&seq=dluxmen-lacoste-polo-1&orientation=portrait',
      brand: 'LACOSTE',
      name: 'Crocodile Polo',
      price: 'R$ 179,90',
      isNew: true
    },
    {
      id: '12',
      image: 'https://readdy.ai/api/search-image?query=luxury%20stone%20island%20style%20hoodie%20for%20men%2C%20premium%20cotton%20with%20sophisticated%20badge%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20hoodie%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-stone-hoodie-1&orientation=portrait',
      brand: 'STONE ISLAND',
      name: 'Premium Hoodie',
      price: 'R$ 329,90'
    }
  ];

  const handleProductClick = (product: any) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8' }}>
      <Header />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=luxury%20menswear%20fabric%20texture%20background%2C%20sophisticated%20textile%20patterns%20with%20emerald%20green%20and%20gold%20accents%2C%20premium%20fashion%20photography%20with%20dramatic%20lighting%2C%20elegant%20masculine%20aesthetic%20without%20people%2C%20high-end%20brand%20visual%20identity&width=1920&height=600&seq=dluxmen-hero-masculino&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
        </div>
        
        <div className="relative z-10 text-white text-center px-6 max-w-4xl mx-auto">
          <h1 
            className="text-5xl md:text-6xl font-bold mb-4"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#C2A15A'
            }}
          >
            DLUXMEN
          </h1>
          <p 
            className="text-xl md:text-2xl mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Where every detail defines luxury.
          </p>
          <p 
            className="text-lg mb-8"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Explore the DLUXMEN Collection – 1.1 & 1.2 Super Clones
          </p>
          <button
            onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3 text-lg font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
            style={{ 
              backgroundColor: '#0F3F2F',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Explore Collection
          </button>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
            {/* Category Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'text-green-800 border-green-800' 
                      : 'text-gray-600 border-transparent hover:text-green-800'
                  }`}
                  style={{ 
                    fontFamily: 'Manrope, sans-serif',
                    borderColor: selectedFilter === filter ? '#0F3F2F' : 'transparent',
                    color: selectedFilter === filter ? '#0F3F2F' : '#666666'
                  }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort Dropdown */}
            <div className="flex items-center space-x-4">
              <span 
                className="text-sm font-medium"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#0B0B0B'
                }}
              >
                Sort by:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-800 focus:border-transparent"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  backgroundColor: '#FFFFFF'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Results Count */}
          <div className="mt-4">
            <p 
              className="text-sm"
              style={{ 
                fontFamily: 'Montserrat, sans-serif',
                color: '#C0C0C0'
              }}
            >
              Showing {products.length} products
            </p>
          </div>
        </div>
      </section>

      {/* Product Grid */}
      <section id="products" className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => handleProductClick(product)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Featured Collections */}
      <section className="py-16" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6">
          <h2 
            className="text-3xl font-bold text-center mb-12"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Featured Collections
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div 
                className="w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#0F3F2F' }}
              >
                <i className="ri-star-line text-3xl text-white"></i>
              </div>
              <h3 
                className="text-xl font-bold mb-2"
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  color: '#0B0B0B'
                }}
              >
                Best Sellers
              </h3>
              <p 
                className="text-sm"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Our most popular pieces
              </p>
            </div>
            
            <div className="text-center">
              <div 
                className="w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#0F3F2F' }}
              >
                <i className="ri-flashlight-line text-3xl text-white"></i>
              </div>
              <h3 
                className="text-xl font-bold mb-2"
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  color: '#0B0B0B'
                }}
              >
                New Arrivals
              </h3>
              <p 
                className="text-sm"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Latest luxury pieces
              </p>
            </div>
            
            <div className="text-center">
              <div 
                className="w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#0F3F2F' }}
              >
                <i className="ri-medal-line text-3xl text-white"></i>
              </div>
              <h3 
                className="text-xl font-bold mb-2"
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  color: '#0B0B0B'
                }}
              >
                Italian Line Highlights
              </h3>
              <p 
                className="text-sm"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Authentic Italian elegance
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About DLUXMEN Banner */}
      <section className="py-12" style={{ backgroundColor: '#0F3F2F' }}>
        <div className="container mx-auto px-6 text-center">
          <h2 
            className="text-3xl font-bold mb-4 text-white"
            style={{ fontFamily: 'Cinzel Decorative, serif' }}
          >
            About DLUXMEN
          </h2>
          <p 
            className="text-lg text-white max-w-2xl mx-auto"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Brazilian brand redefining luxury — real style for real men.
          </p>
          <div 
            className="w-24 h-1 mx-auto mt-6"
            style={{ backgroundColor: '#C2A15A' }}
          ></div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16" style={{ backgroundColor: '#0F3F2F' }}>
        <div className="container mx-auto px-6 text-center">
          <h2 
            className="text-3xl font-bold mb-4 text-white"
            style={{ fontFamily: 'Cinzel Decorative, serif' }}
          >
            Join the DLUXMEN Experience
          </h2>
          <p 
            className="text-lg text-white mb-8 max-w-2xl mx-auto"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Get exclusive drops and offers.
          </p>
          <div className="flex flex-col sm:flex-row max-w-md mx-auto space-y-4 sm:space-y-0 sm:space-x-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-lg border-0 focus:outline-none focus:ring-2 focus:ring-yellow-500"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            />
            <button
              className="px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:bg-yellow-600"
              style={{ 
                backgroundColor: '#C2A15A',
                color: '#0B0B0B',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </section>

      {/* Product Modal */}
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}

      <Footer />
    </div>
  );
}
